"use strict";
(function (CardTags) {
    CardTags[CardTags["ALL"] = 'All'] = "ALL";
    CardTags[CardTags["UX"] = 'UX'] = "UX Research & Design";
    CardTags[CardTags["VISUALDESIGN"] = 'Visual Design'] = "VISUALDESIGN";
    CardTags[CardTags["DEV"] = 'Development'] = "DEV";
    CardTags[CardTags["PRES"] = 'Presentation'] = "PRESENTATION";
    CardTags[CardTags["OTHER"] = 'Other'] = "OTHER";
})(exports.CardTags || (exports.CardTags = {}));
var CardTags = exports.CardTags;
//# sourceMappingURL=types.js.map